import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// Components
import Modal from "../../components/Modal.js";

// Style
import {HeadingCenter, List, ListItem, Text, Warning} from "../../style/components/general.js";
import {pad} from "../../style/components/variables.js";

const ModalEditConflict = ({
  visible,
  setVisible,
  checksheetsNoSiblings,
  goToChecksheet,
  goBack
}) => (
  <Modal visible={visible} setVisible={setVisible} hasBackButton goBack={goBack}>
    <HeadingCenter>Conflict</HeadingCenter>
    {!!checksheetsNoSiblings?.length && (
      <>
        <br />
        <WarningWrapper>
          This component cannot be moved to another group as it is the only element within its
          containing group on {checksheetsNoSiblings.length === 1 ? "an " : ""}affected checksheet
          {checksheetsNoSiblings.length > 1 ? "s" : ""}!
          <br />
          <br />
          In order to save, please either delete the component from the following checksheet
          {checksheetsNoSiblings.length > 1 ? "s" : ""} or provide additional element(s) to the
          containing group of each checksheet before this change.
        </WarningWrapper>
        <br />
        <Text bold quiet>
          Affected Checksheets:
        </Text>
        <List column>
          {checksheetsNoSiblings.map(({id, name, frequency}) => (
            <ListItem key={`checksheet-no-siblings-${id}`} quiet>
              <ChecksheetLink
                onClick={() => {
                  goToChecksheet(id);
                }}>
                {name}
                {frequency?.name ? ` (${frequency.name.toUpperCase()})` : ""}
              </ChecksheetLink>
            </ListItem>
          ))}
        </List>
      </>
    )}
  </Modal>
);

ModalEditConflict.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  goToChecksheet: PropTypes.func.isRequired,
  checksheetsNoSiblings: PropTypes.arrayOf(PropTypes.any),
  goBack: PropTypes.func.isRequired
};

const WarningWrapper = styled(Warning)`
  margin-bottom: ${pad / 2}px;
  color: ${({theme}) => theme.secondary};
`;

const ChecksheetLink = styled.a`
  border: 0;
  background: 0;
  text-decoration: underline;

  svg {
    fill: ${props => props.theme.secondary};
  }
`;

export default ModalEditConflict;
